module.exports = __webpack_public_path__ + "img/128x128_hexagon_carrier.6b151337.svg";